import { B as BxfButton$1, d as defineCustomElement$1 } from './p-8c4c95dc.js';

const BxfButton = BxfButton$1;
const defineCustomElement = defineCustomElement$1;

export { BxfButton, defineCustomElement };
